<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Competencies' }" isRouteLink>Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <argon-button :to="{ name: 'Competencies' }" isRouteLink outline>Batalkan</argon-button>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Kompetensi Baru"
                description="Masukkan informasi detail untuk master data kompetensi karyawan baik Kompetensi Inti maupun Kompetensi Manajerial. ">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Kompetensi" idinput="name">
                    <input type="text" name="name" id="name" class="form-control"
                      placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.name">
                  </form-group>

                  <form-group label="Jenis Kompetensi">
                    <select-form v-model="data.type" :options="[
                      {
                        text: 'inti',
                        value: 'inti'
                      },
                      {
                        text: 'manajerial',
                        value: 'manajerial'
                      },
                    ]" />
                    <!-- <select style="text-transform: capitalize;" name="type" id="type" class="form-control" v-model="data.type">
                      <option v-for="item in ['inti','manajerial']" :key="item" :value="item">{{ item }}</option>
                    </select> -->
                  </form-group>

                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="active" v-model="data.status" name="status"
                        id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="inactive" v-model="data.status" name="status"
                        id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>

              <FieldsetComponent title="Detail Kompetensi"
                hint="Ice cream tart oat cake shortbread jelly beans macaroon marshmallow. Sesame snaps halvah tiramisu cake jujubes jelly-o icing cupcake gingerbread.">

                <form-group label="Keterangan level 1">
                  <input type="text" name="level1" id="level1" class="form-control"
                    placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.level1">
                </form-group>
                
                <form-group label="Keterangan level 2">
                  <input type="text" name="level2" id="level2" class="form-control"
                    placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.level2">
                </form-group>
                
                <form-group label="Keterangan level 3">
                  <input type="text" name="level3" id="level3" class="form-control"
                    placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.level3">
                </form-group>
                
                <form-group label="Keterangan level 4">
                  <input type="text" name="level4" id="level4" class="form-control"
                    placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.level4">
                </form-group>
                
                <form-group label="Keterangan level 5">
                  <input type="text" name="level5" id="level5" class="form-control"
                    placeholder="Silakan tulis nama kompetensi disini disini..." v-model="data.level5">
                </form-group>
                
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import KpiCompetenciesApi from "@/repository/api/KpiCompetenciesApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import SelectForm from '@/components/SelectForm.vue';


export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      data: {},
      unitKerja: [
        {}
      ],
      employee: [{}],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      jabatan: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',
    };
  },
  components: { FieldsetComponent, Cards, FormGroup, ArgonButton, MetaSection, GridRow, GridCol, SelectForm },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
  },
  methods: {
    async submit() {
      this.$store.state.loading = true;
      if (this.$route.params.id) {
        await KpiCompetenciesApi.update(this.$route.params.id, this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Competencies" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      else {
        await KpiCompetenciesApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Competencies" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await KpiCompetenciesApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Competencies" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
